import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const RegistersModule = lazy(loadModule);

export default RegistersModule;
